import React from 'react'

const Card = ({course, courseHandler}) => {
    return (
        <button 
            onClick={() => { courseHandler(course) }} 
            className='h-52 w-36 hover:scale-105 flex flex-col items-center p-4 border-2 shadow-lg bg-gradient-to-b from-sky-100 to-blue-100 mx-auto transition-all duration-300 relative group'
            style={{
                borderLeft: '12px double #1e40af',
                borderRight: '1px solid #cbd5e1',
                borderTop: '1px solid #cbd5e1', 
                borderBottom: '1px solid #cbd5e1',
                borderRadius: '2px 8px 8px 2px'
            }}
        >
            {/* Book spine effect */}
            <div className="absolute left-0 top-0 w-3 h-full bg-gradient-to-b from-blue-700 to-blue-800 opacity-80"></div>
            
            {/* Book pages effect on the right side */}
            <div className="absolute right-0 top-2 bottom-2 w-1 bg-gray-200 opacity-60"></div>
            <div className="absolute right-1 top-3 bottom-3 w-1 bg-gray-300 opacity-40"></div>
            
            {/* Book content */}
            <div className="relative z-10 w-full h-full flex flex-col justify-center items-center p-2">
                <div className="w-full h-1 bg-gradient-to-r from-yellow-400 to-orange-400 mb-3 rounded-full"></div>
                <p className='text-sm font-bold text-gray-800 leading-tight text-center line-clamp-4 group-hover:text-blue-800 transition-colors'>
                    {course.title}
                </p>
                <div className="w-full h-1 bg-gradient-to-r from-yellow-400 to-orange-400 mt-3 rounded-full"></div>
            </div>
            
            {/* Subtle shadow for depth */}
            <div className="absolute inset-0 rounded-lg shadow-inner border border-gray-200 pointer-events-none"></div>
        </button>
    );
}

export default Card;
